module.exports = __webpack_public_path__ + "static/img/F_2018_SDG_Poster_with_UN_emblem.36a5284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/F_2018_SDG_Poster_with_UN_emblem.png
// module id = aK8Z
// module chunks = 0